import type { CGMSessionEndedActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import { CGMType } from "@tandemdiabetes/sugarmate-api-react-client"
import { forwardRef } from "react"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { usePolyglot } from "src/contexts"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: CGMSessionEndedActivity;
}

export const CGMSessionEndedMessage = forwardRef<HTMLDivElement, Props>(
  function CGMSessionEndedMessage(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity, ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    if (activity.cgm_type === CGMType.Undefined) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t(
          "components.activity_summary.message.device_summary",
          {
            device: polyglot.t(
              `device.${activity.cgm_type}`,
            ),
          },
        )}
      </div>
    )
  },
)
